import { render, staticRenderFns } from "./OnboardCardholdersLayout.vue?vue&type=template&id=d1d8f512"
import script from "./OnboardCardholdersLayout.vue?vue&type=script&lang=js"
export * from "./OnboardCardholdersLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports